import React from 'react';
import { useMarketingCourses } from '../MarketingData';

/** Utility-theme top status bar. Dark band, mono text, green LED + open-cohort
 *  count derived from the shared course list. */
export const UtilityTopbar: React.FC = () => {
  const { courses, loaded } = useMarketingCourses();
  const count = courses.length;

  return (
    <div className="util-topbar bg-[var(--util-ink)] text-[var(--util-paper)] py-2 font-util-mono text-[11px] tracking-[0.02em]">
      <div className="max-w-[1320px] mx-auto px-6 flex justify-between items-center gap-4 flex-wrap">
        <div className="flex items-center gap-1.5">
          <span className="util-led inline-block w-2 h-2 rounded-full bg-[#2f7a3a] mr-1.5" />
          {!loaded
            ? 'Loading…'
            : count === 0
              ? 'Spring 2026 cohort · catalogue empty'
              : `Spring 2026 cohort · open · ${count} ${count === 1 ? 'programme' : 'programmes'}`}
        </div>
        <div className="hidden sm:flex items-center gap-4 opacity-80">
          <a href="#" className="hover:opacity-100 transition-opacity">docs</a>
          <a href="#" className="hover:opacity-100 transition-opacity">changelog</a>
          <a href="#" className="hover:opacity-100 transition-opacity">syllabus.pdf ↗</a>
        </div>
      </div>
    </div>
  );
};
